export default "__VITE_ASSET__DiWEfeKO__"